import { FILTER_KEYS } from '@/utils/consts';
import { ECOMMERCE_CHANNELS } from '@/utils/dashboard';

export const OUTER_CONDITIONS_PATH = [0, 'conditions'];

export const LOGICAL_OPERATOR = {
    and: 'AND',
    or: 'OR',
};

export const OPERATOR = {
    in: 'IN',
    notIn: 'NOT_IN',
    like: 'LIKE',
    notLike: 'NOT_LIKE',
    startsWith: 'STARTS_WITH',
    endsWith: 'ENDS_WITH',
    regexp: 'REGEXP',
};

export const NOT_OPERATOR = [OPERATOR.notIn, OPERATOR.notLike];

export const COMPLEMENT_OPERATOR_MAP = {
    [OPERATOR.in]: OPERATOR.notIn,
    [OPERATOR.like]: OPERATOR.notLike,
    [OPERATOR.notIn]: OPERATOR.in,
    [OPERATOR.notLike]: OPERATOR.like,
};

// for generic filter (outer: or, inner: and)
export const DEFUALT_AND_CONDITION = {};

export const DEFUALT_OR_CONDITION = {
    operator: LOGICAL_OPERATOR.and,
    conditions: [DEFUALT_AND_CONDITION],
};

export const DEFAULT_AND_OR_FILTER = [
    {
        operator: LOGICAL_OPERATOR.or,
        conditions: [DEFUALT_OR_CONDITION],
    },
];

export const GENERIC_OPTIONS = {
    MCF: 'mcf',
    GA: 'ga',
};

const { CHANNEL, TITLE, ID, AD_ACCOUNT_ID, UTM, GENERIC } = FILTER_KEYS;
export const MULTIPLE_VALUE_AVAILABLE_FIELDS = [
    TITLE,
    CHANNEL,
    ID,
    AD_ACCOUNT_ID,
    UTM,
    GENERIC,
];

export const ALL_OPERATOR_AVAILABLE_GENERIC_SOURCES = [
    'ga',
    'mcf',
    'gss',
    'ga4',
    ...Array.from(ECOMMERCE_CHANNELS),
];
